<template>
	<div class="content-wrapper" v-if="this.$can('view_list_student_studentprofile_tab_schedule_assign_schedule')">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Assign Schedule" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<!-- <button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button> -->
					<button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="reloadTable"
					>
						<i class="fa fa-sync"></i>
						Refresh Table
					</button>
					<button
						type="button"
						class="btn btn-secondary btn-with-shadow"
						:disabled="invoiceRequestButtonDisabled"
						@click="createInvoiceRequest"
					>
						Invoice Request
					</button>
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button>
				</div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table
			:id="tableId"
			:options="options"
			@action="getListAction"
			:scheduleRecommendationTableHideFunc="
				scheduleRecommendationTableHideFunc
			"
			:scheduleRecommendationTableHideVal="
				scheduleRecommendationTableHideVal
			"
		/>

		<!-- <app-add-modal
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/> -->

		<assign-schedule-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:row-data="rowData"
			:clc-id-number="this.value.clc_id_number"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>

		<assign-schedule-second-form
			v-if="isAddEditSecondModalActive"
			:table-id="tableId"
			:form-id="'assign-schedule-second-form'"
			:row-data="rowData"
			:assign-schedule-id="rowData.id"
			:value="rowData"
			@close-modal="closeAddEditSecondModal"
		/>

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { AssignScheduleTableSchema } from "./AssignScheduleTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";
import { ASSIGN_SCHEDULE } from "../../../../../../../Config/ApiUrl.js";

export default {
	extends: CoreLibrary,
	name: "AssignScheduleTable",
	mixins: [AssignScheduleTableSchema],
	inject: ["eventHub"],
	props: {
		scheduleRecommendationTableHideFunc: {
			type: Function,
		},
		scheduleRecommendationTableHideVal: {
			type: Boolean,
		},
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			listSelectedAssignSchedule: [],
			invoiceRequestButtonDisabled: true,
		};
	},
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
	},
	mounted() {
		this.eventHub.$on(
			"studentSelectAssignSchedule",
			(listSelectedAssignSchedule) => {
				this.listSelectedAssignSchedule = listSelectedAssignSchedule;

				// Set the button disabled state based on invoice_id presence
				this.invoiceRequestButtonDisabled =
					this.listSelectedAssignSchedule.some(
						(item) => item.invoice_id !== null
					);

				// Disable the button if the list is empty
				if (this.listSelectedAssignSchedule.length === 0) {
					this.invoiceRequestButtonDisabled = true;
				}
			}
		);
		this.eventHub.$on(
			"studentScheduleRecommendationOnScheduleTabDeleted",
			() => {
				this.$hub.$emit("reload-" + this.tableId);
			}
		);
		this.eventHub.$on(
			"studentCreatedAssignScheduleFromPlacementBooking",
			() => {
				this.$hub.$emit("reload-" + this.tableId);
			}
		);
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},
		openAddEditScheduleModal() {
			this.isAddEditSecondModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#assign-schedule-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},
		closeAddEditSecondModal() {
			$("#assign-schedule-second-form").modal("hide");
			this.isAddEditSecondModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;
			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = ASSIGN_SCHEDULE + "/" + rowData.id;
				this.openAddEditModal();
			} else if (
				actionObj.title != "Delete" ||
				actionObj.title != this.$t("edit")
			) {
				this.selectedUrl = ASSIGN_SCHEDULE + "/" + rowData.id;
				if ((actionObj.modalId = "assign-schedule-second-form")) {
					this.openAddEditScheduleModal();
				} else {
					this.openAddEditModal();
				}
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = ASSIGN_SCHEDULE + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
					this.eventHub.$emit("studentAssignScheduleOnTabScheduleDeleted");
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},

		// Invoice Request
		createInvoiceRequest() {
			const hasNullRecommendation = this.listSelectedAssignSchedule.some(
				(item) =>
					!item.schedule_recommendation ||
					item.schedule_recommendation.length === 0 ||
					item.schedule_recommendation[0] === null
			);

			const hasInvoice = this.listSelectedAssignSchedule.some(
				(item) => item.invoice_id !== null
			);

			if (hasNullRecommendation) {
				this.listSelectedAssignSchedule = [];
				this.$hub.$emit("reload-" + this.tableId);
				this.eventHub.$emit("studentListSelectedAssignScheduleChanged");
				Swal.fire({
					title: "Failed",
					text: "Some items have null or empty schedule recommendations.",
					icon: "error",
				});
				return;
			} else if (hasInvoice) {
				this.listSelectedAssignSchedule = [];
				this.$hub.$emit("reload-" + this.tableId);
				this.eventHub.$emit("studentListSelectedAssignScheduleChanged");
				Swal.fire({
					title: "Failed",
					text: "Some items already has invoice.",
					icon: "error",
				});
				return;
			} else {
				Swal.fire({
					title: "Are you sure?",
					text: "You won't be able to revert this!",
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Yes, create it!",
					cancelButtonText: "No, cancel!",
					reverseButtons: true,
				}).then((result) => {
					if (result.isConfirmed) {
						let url = `transaction/invoice`;
						let promises = [];

						// Loop to create Axios requests and store promises
						this.listSelectedAssignSchedule.forEach((item) => {
							if (item.schedule_recommendation[0] != null) {
								let promise = this.axiosPost({
									url: url,
									data: {
										clc_id_number: item.clc_id_number,
										request_date: this.formattedDate(
											new Date()
										),
										// request_user_id: "",
										request_send_to: this.value.parent_id,
										request_send_via: "WhatsApp or Email",
										request_print_date: "2023-11-21",
										due_date: "2023-11-21",
										// remarks: "",
										// status: "",
										sub_total: 0,
										grand_total: 0,
										items: [
											{
												assign_schedule_id: item.id,
												schedule_recommendation_id:
													item.schedule_recommendation
														.length > 0
														? item
																.schedule_recommendation[0]
																.id
														: 1,
												course_id:
													item.schedule_recommendation
														.length > 0
														? item
																.schedule_recommendation[0]
																.course_id.id
														: 1,
												product_id: item.product_id.id,
											},
										],
									},
								});
								promises.push(promise);
							}
						});

						// Wait for all promises to resolve
						Promise.all(promises)
							.then((responses) => {
								let successCount = responses.filter(
									(response) => response.status === 200
								).length;
								let failedCount =
									responses.length - successCount;

								let title, text, icon;

								if (
									successCount ===
										this.listSelectedAssignSchedule
											.length &&
									failedCount === 0
								) {
									title = "Success";
									text = `${successCount} Invoice Requests Created`;
									icon = "success";
								} else if (
									failedCount ===
										this.listSelectedAssignSchedule
											.length &&
									successCount === 0
								) {
									title = "Failed";
									text = `${failedCount} Invoice Requests Failed, please kindly re-check the data.`;
									icon = "error";
								} else {
									title = "Success & Failed";
									text = `${successCount} Invoice Requests Created, ${failedCount} Failed, please kindly re-check the data.`;
									icon = "warning";
								}

								// Clear list selected
								this.listSelectedAssignSchedule = [];
								this.$hub.$emit("reload-" + this.tableId);
								this.eventHub.$emit(
									"studentListSelectedAssignScheduleChanged"
								);
								this.eventHub.$emit(
									"studentInvoiceRequestCreatedFromAssignSchedule"
								);

								Swal.fire({
									title,
									text,
									icon,
								});
							})
							.catch((error) => {
								console.error("Error:", error);
								Swal.fire({
									title: "Error",
									text: "Something went wrong",
									icon: "error",
								});
							});
					} else if (result.dismiss === Swal.DismissReason.cancel) {
						Swal.fire({
							title: "Cancelled",
							text: "Create Invoice Request Cancelled :)",
							icon: "error",
						});
					}
				});
			}
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
		},
	},
};
</script>
